import { createReducer } from 'shared';
import { fetchAppQrRelations } from 'redux/actions';
import uniq from 'lodash/uniq';

export const appQrRelationsIdsReducer = createReducer([], {
  [fetchAppQrRelations]: (ids, action) => uniq([...ids, ...action.ids]),
});
